import '../App.css';
import { useEffect } from 'react';
import NameForm from '../components/forms/NameForm';
import Header from '../components/ui/Header';
import UpdateNotification from '../components/UpdateNotification';
import { useScreenLayout } from '../helpers/utils/useScreenLayout';
import { preloadCalculatorWhenIdle } from './calculatorRoute';

function HomePage() {
  const layout = useScreenLayout();
  // Start and Continue then go straight to the board.
  useEffect(() => preloadCalculatorWhenIdle(), []);
  return (
    <div className="App" data-layout={layout}>
      <UpdateNotification />
      <Header />
      <NameForm />
    </div>
  );
}

export default HomePage;
